import { getSignedUrl, getDocumentsV2 } from 'utils/DocumentsAPIUtils';
import fileDownload from 'react-file-download';
import { showToast } from 'stores/ToastStore';
import { t } from 'i18next';
export const shipmentTypesForDisplayRateCard = ['drayage'];
export const getPdfUrl = async (docKey) => {
    try {
        const { data: { getSignedUrl: getSignedUrlData }, } = await getSignedUrl(docKey);
        return getSignedUrlData === null || getSignedUrlData === void 0 ? void 0 : getSignedUrlData.signedUrl;
    }
    catch (e) {
        showToast('', t('GENERATE_AGAIN_RATE_CARD'), 'error');
    }
};
export const fetchDocuments = async (accountId = '', docType) => {
    var _a;
    const { data } = await getDocumentsV2(accountId, docType, {
        order: {
            field: 'createdAt',
            direction: 'desc',
        },
    });
    const { getDocumentsV2: docsData } = data;
    if ((_a = docsData === null || docsData === void 0 ? void 0 : docsData.documents) === null || _a === void 0 ? void 0 : _a.length) {
        const { key: documentKey, createdAt: generatedOn } = docsData.documents[0];
        const pdfUrl = await getPdfUrl(documentKey);
        return { documentKey, generatedOn, pdfUrl };
    }
};
export const handleDownloadRateCard = async (pdfUrl, openInNewTab = false) => {
    const response = await fetch(pdfUrl);
    const blob = await response.blob();
    if (openInNewTab) {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
    }
    else {
        fileDownload(blob, 'rate-card.pdf');
    }
};
